//Delta-Number component to show a number with its sign and color based on its value
import { Component, Input } from '@angular/core';
import { Utils } from 'src/app/services/utils';

@Component({
  selector: 'delta-number',
  templateUrl: './delta-number.html',
  styleUrls: ['./delta-number.scss']
})
export class DeltaNumberComponent {
    @Input() value: number;
    @Input() showSign: boolean = true;
    @Input() showColor: boolean = true;

    constructor(private _utils: Utils) {}

    get showValue(): string {
        const formatedValue = this._utils.formatNumber(this.value);
        return this.showSign ? this.sign + formatedValue : formatedValue;
    }

    get sign(): string {
        return this.value > 0 ? '+' : '';
    }

    get color(): string {
        return this.value > 0 ? 'green' : this.value < 0 ? 'red' : '';
    }
}

